import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./AdminHeader.module.scss";
import { AppDispatch, RootState } from "../../Redux/store";
import useClick from "../../Hooks/useClick";
import { logoutUser } from "../../Redux/Auth/AuthActions";
import { Link } from "react-router-dom";
import { uploadSpreadsheet } from "../../Redux/Upload/UploadAction";
import { toast } from "react-hot-toast";
import { ClipLoader } from "react-spinners";

function AdminHeader() {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.auth);
  const { upload_spreadsheet_loading } = useSelector(
    (state: RootState) => state.upload
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    isActive: isDropdownActive,
    setIsActive: setIsDropdownActive,
    ref,
  } = useClick(false);

  const logoutHandler = () => {
    dispatch(logoutUser());
  };

  const uploadFileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      e.target.value = "";
      return;
    }

    const validMimeType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const validExtension = file.name.toLowerCase().endsWith(".xlsx");

    if (file.type !== validMimeType || !validExtension) {
      toast.error("Only excel files are allowed");
      e.target.value = "";
      return;
    }

    if (!upload_spreadsheet_loading) {
      console.log(file);
      dispatch(uploadSpreadsheet(file));
    }

    e.target.value = "";
  };

  return (
    <div className={styles.mainContainer}>
      <Link className={styles.logoContainer} to="/admin">
        <h1 className={styles.logo}>RRT</h1>
      </Link>
      <div className={styles.rightContainer}>
        <div className={styles.linksContainer}>
          <div className={styles.link}>
            <input
              type="file"
              accept=".xls,.xlsx"
              ref={inputRef}
              hidden
              onChange={uploadFileHandler}
            />
            <button
              className={styles.linkText}
              onClick={() => {
                if (!upload_spreadsheet_loading) {
                  inputRef.current?.click();
                }
              }}
            >
              Upload ZipCode Spreadsheet{" "}
              <ClipLoader
                color="white"
                size={10}
                loading={upload_spreadsheet_loading}
              />
            </button>
          </div>

          <div className={styles.link}>
            <Link className={styles.linkText} to="/admin/email-logs">
              Email Logs
            </Link>
          </div>

          <div className={styles.link}>
            <Link className={styles.linkText} to="/admin/search-logs">
              Search Logs
            </Link>
          </div>

          <div className={styles.link}>
            <Link className={styles.linkText} to="/admin/job-list">
              Auto Job List
            </Link>
          </div>

          <div className={styles.link}>
            <Link className={styles.linkText} to="/jh">
              Job Intake
            </Link>
          </div>
        </div>
        <div className={styles.nameContainer}>
          <p className={styles.name}>
            {user?.firstName} {user?.lastName}
          </p>
        </div>

        <div
          className={styles.menuContainer}
          ref={ref}
          onClick={() => setIsDropdownActive(true)}
        >
          <div
            className={
              isDropdownActive
                ? styles.dropdownContainerActive
                : styles.dropdownContainer
            }
          >
            <button onClick={logoutHandler}>Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHeader;
